import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import TsPenetrationChart from './TsPenetrationChart';
import SectionError from '../SectionError';
import Tooltip from '../../../../components/Tooltip';
import SimpleCard from '../../../../components/Card/SimpleCard';
import OverPeriodDropdown, {
  periodChangeTypeCaptures,
} from '../../../../components/OverPeriodDropdown';
import { timeSpentPenetrationSelector } from '../../selectors';
import { fetchTimeSpentPenetration } from '../../actions';
import { ADVANCED_METRICS_APP_DESCRIPTION } from '../../../../utils/advanced-metrics';

const metricOption = {
  value: 'time_spent_penetration',
  label: 'Time Spent Penetration',
};

const TsPenetration = () => {
  const dispatch = useDispatch();

  const { data, settings, filters } = useSelector(timeSpentPenetrationSelector);

  const handlePeriodChange = (value) => {
    dispatch(fetchTimeSpentPenetration({ change_type: value }));
  };

  if (settings.error) return <SectionError />;

  return (
    <SimpleCard
      headerLeft={
        <>
          <h3 className="h3 header-heading">Share of Screen Time</h3>
          <p className="header-description">
            Shows how much of total user attention AI apps capture compared to all other apps in the
            panel. View trends over time and measure changes year over year or within the selected
            period.
          </p>
        </>
      }
      headerRight={
        <OverPeriodDropdown
          selected={filters.change_type}
          disabled={settings.pending}
          menuAlign="end"
          onChange={handlePeriodChange}
        />
      }
      actionsLeft={<div className="highcharts-watermark" />}
    >
      <div className="d-flex flex-column gap-16">
        <h4 className="section-body-header__title">
          Time Spent Penetration{' '}
          <span className="label-caption">{periodChangeTypeCaptures[filters.change_type]}</span>
          <Tooltip
            colorVariant="light"
            content={ADVANCED_METRICS_APP_DESCRIPTION[metricOption.value]}
            overlayStyle={{ maxWidth: 324 }}
          >
            <i className="hicon-question-circle" />
          </Tooltip>
        </h4>
        <TsPenetrationChart
          metricOption={metricOption}
          series={data}
          isPending={settings.pending}
        />
      </div>
    </SimpleCard>
  );
};

export default TsPenetration;
